// 惰性スクロール
import Lenis from 'lenis';
import { setLenisInstance } from './lenis-instance.js';

document.addEventListener('DOMContentLoaded', function(event) {
  const isTouch = 'ontouchstart' in document;
  if (!isTouch) {
    // console.log('start');
    const lenis = new Lenis({
    autoRaf: true,
    prevent: (node) => node.classList.contains('js-smooth-scroll-prevent'),
    // ヘッダー固定の場合(ヘッダークラス名は要注意)
      // anchors: {
      //   offset: Math.floor(document.querySelector('.l-header').clientHeight) * -1,
      //   // onComplete: ()=>{  // callback
      //   //   console.log('scrolled to anchor')
      //   // }
      // },
    // ヘッダー固定出ない場合
      // anchors: true,
    });
    setLenisInstance(lenis);
    window.setSmoothScroll = true;
  }
  
});